import { assert } from "@/common/assert";

type DataValueType = string | number | boolean;

function _optionalVal($el: JQuery, key: string): DataValueType | undefined {
    assert($el, "$el is null");
    const val = $el.data(key) as DataValueType;
    if (typeof val === "undefined") return;
    return val;
}

const jqueryDataUtil = {
    optionalString($el: JQuery, key: string): string | undefined {
        const val = _optionalVal($el, key);
        if (typeof val === "undefined") return;
        assert(typeof val === "string", `val not string, key: ${key}, type: ${typeof key}`);
        return val;
    },

    requiredString($el: JQuery, key: string): string {
        const val = jqueryDataUtil.optionalString($el, key);
        assert(val, `${key} is required`);
        return val;
    },
    optionalNumber($el: JQuery, key: string): number | undefined {
        const val = _optionalVal($el, key);
        if (typeof val === "undefined") return;
        const n = Number(val);
        assert(typeof n === "number" && !isNaN(n), `${key} is not a valid number`);
        return n;
    },
    requiredNumber($el: JQuery, key: string): number {
        const val = jqueryDataUtil.optionalNumber($el, key);
        assert(typeof val === "number", `${key} is a required number`);
        return val;
    },
    optionalBoolean($el: JQuery, key: string): boolean | undefined {
        const val = _optionalVal($el, key);
        if (typeof val === "undefined") return;
        assert(typeof val === "boolean", `${key} is required to be "true" or "false", but is ${val}`);
        return val;
    },
    requiredBoolean($el: JQuery, key: string): boolean {
        const val = jqueryDataUtil.optionalBoolean($el, key);
        assert(typeof val === "boolean", `${key} is required`);
        return val;
    },
};

export default jqueryDataUtil;
